export default function FormLabel({text}: { text: string }) {
	return (
		<span style={
			{
				fontFamily: "PingFang SC",
				fontWeight: 500,
				fontSize: "1rem",
				lineHeight: "1.5rem",
			}
		}
		>
			{text}
		</span>
	);
}
